export interface GetInvoiceListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetInvoiceListPagingAndFilterResponseData
}

export interface GetInvoiceListPagingAndFilterResponseData {
    items: GetInvoiceListPagingAndFilterResponseItem[]
    totalRecordCount: number
    totals: GetInvoiceListPagingAndFilterResponseTotals | undefined
}

/** Görüntülenen sayfadaki kayıtların dip toplamı. */
export interface GetInvoiceListPagingAndFilterResponseTotals {
    totalPrice: string
    taxPrice: string
    totalWithoutTaxPrice: string
    withholdingPrice: string
    localTotalPrice: number
    localTaxPrice: number
    localWithholdingPrice: number
    localTotalWithoutTaxPrice: number
    rowCount: number
}

export interface GetInvoiceListPagingAndFilterResponseItem {
    invoiceId: string
    companyId: string
    isSale: boolean
    isPurchase: boolean
    isRefund: boolean
    refNo: string
    invoiceStatusId: string
    currencyTypeId: string
    currentCompanyId: string
    invoiceDate: string
    currencyDate: string
    currentCompanyAddressTypeId: string
    serialNo: string
    currencyRateTypeId: string
    addressText: string
    paymentTypeId: string
    currency: number
    moduleId: string
    maturityPeriodId: string
    invoiceTypeId: string
    operationTypeId: string
    paymentDate: string
    paymentDateStr: string
    transferDate: any
    invoiceCategoryId: string
    invoiceStatusName: string
    efaturaStatusName?: string
    /** e-Fatura / e-Arşiv (Uyumsoft numarasından: MER = e-Arşiv); gönderilmemişte boş. */
    faturaTuru?: string | null
    efaturaStatusMessage?: string
    efaturaStatusDateStr?: string
    currencyTypeName: string
    currentCompanyName: string
    currentCompanyAddressTypeName: string
    currencyRateTypeName: string
    currencyRateTypeKey: string
    paymentTypeName: string
    paymentTypeKey: string
    moduleName: string
    maturityPeriodName: string
    maturityPeriodKey: string
    invoiceTypeName: string
    operationTypeName: string
    invoiceCategoryName: string
    description: string
    invoiceDetails: InvoiceDetail[]
    fileArchives: FileArc[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface InvoiceDetail {
    invoiceDetailId: string
    invoiceId: string
    serviceId: string
    unitPrice: number
    quantity: number
    taxRate: number
    totalPrice: number
    taxPrice: number
    totalWithoutTaxPrice: number
    exceptionId: string
    description: string
    serviceName: string
    exceptionName: string
}

export interface FileArc {
    fileArchiveId: string
    entityId: string
    fileName: string
    url: string
    fileTypeId: string
    description: string
    fileTypeName: string
    createdDate: string
}

export const initialGetInvoiceListPagingAndFilterResponseData: GetInvoiceListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0,
    totals: undefined
}